import { render, staticRenderFns } from "./OrientationPoll.vue?vue&type=template&id=6847f623&scoped=true&"
import script from "./OrientationPoll.vue?vue&type=script&lang=js&"
export * from "./OrientationPoll.vue?vue&type=script&lang=js&"
import style0 from "./OrientationPoll.vue?vue&type=style&index=0&id=6847f623&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6847f623",
  null
  
)

export default component.exports